import { render, staticRenderFns } from "./goals-chart.vue?vue&type=template&id=dc7bfa4c&scoped=true&"
import script from "./goals-chart.vue?vue&type=script&lang=js&"
export * from "./goals-chart.vue?vue&type=script&lang=js&"
import style0 from "./goals-chart.vue?vue&type=style&index=0&id=dc7bfa4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7bfa4c",
  null
  
)

export default component.exports